import styled from "styled-components/macro";
import { theme } from "../../styles/theme";

export const ToggleDiv = styled.div`
  margin-bottom: 8px;
  `;


export const ToggleTitle = styled.p<{ selected: boolean }>`
  width: fit-content;
  font-size: 20px;
  color: ${(props) =>
    props.selected ? props.theme.colors.text : props.theme.colors.textGray};
  border-bottom: ${({ selected }) =>
    `2px solid ${selected ? theme.colors.text : "transparent"}`};
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.text};
  }

`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  & > div:nth-child(1) {
    display: flex;
  }
  & ul li {
    color: ${(props) => props.theme.colors.text};
  }
  & p:not(:nth-last-child(1)) {
    margin-right: 24px;
  }
`;
